<template>
    <div>
        <v-container fluid>
            <div v-if="loading">
                <v-layout wrap>
                    <v-flex 
                        xs12 
                        px-3
                    >
                        <v-skeleton-loader 
                            class="mx-auto" 
                            type="heading"
                        />
                    </v-flex>
                </v-layout>
                <br>
                <v-layout wrap>
                    <v-col 
                        v-for="i in [1, 2, 3]" 
                        :key="'sl_pss_' + i" 
                        cols="12"
                    >
                        <v-skeleton-loader
                            ref="skeleton"
                            :tile="true"
                            type="image"
                            class="mx-auto"
                        />
                    </v-col>
                </v-layout>
            </div>
            <v-alert 
                v-else-if="idEstatus === '2'" 
                type="info"
            >
                La solicitud se encuentra pendiente de validación.
            </v-alert>
            <v-alert 
                v-else-if="idEstatus === '5'" 
                type="info"
            >
                La solicitud se ya ha sido validada.
            </v-alert>
            <div v-else-if="valido && !loading">
                <plantilla-solicitud-servicio
                    :id-servicio="idServicio"
                    :clave-servicio="claveServicio"
                    :id-estatus="idEstatus"
                />
            </div>
            <v-alert 
                v-else 
                type="error"
            >
                {{ error }}
            </v-alert>
        </v-container>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { getEstatusServicioDisponible } from "@/api";

export default {
  name: "SolicitudServicio",
  components: {
    PlantillaSolicitudServicio: () =>
      import("../../components/organisms/PlantillaSolicitudServicio")
  },
  props: {
    idServicio: {
      type: String,
      default: "0"
    },
    claveServicio: {
      type: String,
      default: ""
    },
    idEstatus: {
      type: String,
      default: "0"
    }
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      valido: false,
      loading: true,
      error: ""
    };
  },
  computed: {
    ...mapGetters("oidc", ["oidcUser"]),
    ...mapState(['empleadoDatos', 'profile']),
    esExterno () {
      return this.profile.Es_Externo
    }
  },
  watch:{
    esExterno: {
      handler (newValue, oldValue) {
        //if(newValue != null) {
          this.validarAcceso();
        //}
      },
    },
  },
  beforeMount () {},
  mounted () {
    if(this.esExterno == true) {
      this.validarAcceso();
    }
  },
  methods: {
    async validarAcceso () {
      var self = this;
      self.loading = true;
      self.valido = false;

      if (this.profile.Es_Externo == 1) {
        try {
          let response = await getEstatusServicioDisponible(
            self.idServicio,
            self.claveServicio
          );
          if (response.status === 200) {
            if (response.data.flag === true) {
              if (self.idEstatus == response.data.data.idEstatus) {
                self.loading = false;
                self.valido = true;
                self.error = "";
              } else {
                self.loading = false;
                self.valido = false;
                self.error =
                  "Ocurrió un problema al consultar la solicitud de servicio";
              }
            } else {
              self.loading = false;
              self.valido = false;
              self.error = response.data.message;
            }
          } else {
            self.loading = false;
            self.valido = false;
            self.error = "Solicitud servicio: Error de red";
          }
        } catch (e) {
          self.loading = false;
          self.valido = false;
          self.error = "Solicitud servicio: " + e;
        }
      } else {
        self.error =
          "Usted no cuenta con el permiso para acceder a esta página.";
        self.valido = false;

        self.loading = false;
      }
    }
  }
};
</script>
